import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('bewhy-theme');
    if (saved) return saved;
    const hour = new Date().getHours();
    return (hour >= 6 && hour < 18) ? 'light' : 'dark';
  });

  const [isTransitioning, setIsTransitioning] = useState(false);
  const [microCopy, setMicroCopy] = useState('');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('bewhy-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setIsTransitioning(true);
    const next = theme === 'dark' ? 'light' : 'dark';
    setMicroCopy(next === 'light' ? 'Melihat lebih jernih...' : 'Mulai bermimpi...');

    setTimeout(() => {
      setTheme(next);
      setTimeout(() => {
        setIsTransitioning(false);
        setMicroCopy('');
      }, 800);
    }, 200);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isTransitioning, microCopy }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
